import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;
const api = new API(BASE_URL);
const downloadAPI = new API(BASE_URL, null, {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  responseType: 'blob',
});

class DocumentService {
  static fetchDocumentConfig = query => api.get(urls.DOCUMENT.FETCH_DOCUMENT_CONFIG, null, query);

  static uploadDocument = (body, params) => api.post(urls.DOCUMENT.UPLOAD_DOCUMENT, body, params);

  static deleteDocument = params => api.delete(urls.DOCUMENT.DELETE_DOCUMENT, null, params);

  static downloadDocument = data => downloadAPI.get(urls.DOCUMENT.DOWNLOAD_DOCUMENT, null, data);

  static downloadDocumentV2 = data => api.get(urls.DOCUMENT.DOWNLOAD_DOCUMENT, null, data);

  static fetchApplicationDocuments = data => api.get(urls.DOCUMENT.FETCH_DOCUMENTS, null, data);

  static fetchRequiredCompanyDocuments = params => api.get(urls.DOCUMENT.FETCH_REQUIRED_COMPANY_DOCS, null, params);

  static downloadCertificate = id => downloadAPI.get(urls.DOCUMENT.DOWNLOAD_CERTIFICATE, id);

  static fetchPropertyMapById = id => api.get(urls.PROPERTY_SERVICE.MAP_PROPERTY, id);

  static downloadContractCOntractId = id => api.get(urls.LEASE.APPLICATION_PDF_CONTRACT, id);

  static downloadDocumentOffPlan = (id, param) => downloadAPI.get(urls.DOCUMENT.DOWNLOAD_DOCUMENT_OFFPLAN, id, param);

  static downloadDocumentOffPlanApplication = id => downloadAPI.get(urls.OFFPLAN.OFFPLAN_APPLICATION_PDF, id);

  static downloadDocumentOffPlanContract = id => downloadAPI.get(urls.OFFPLAN.OFFPLAN_CONTRACT_PDF, id);

  static downloadContractMusataha = id => downloadAPI.get(urls.DOCUMENT.DOWNLOAD_CONTRACT_MUSATAHA, id);

  // static downloadELMSDocument = data => downloadAPI.get(urls.DOCUMENT.DOWNLOAD_ELMS_DOCUMENT, null, data);

  static verifyDocuments = payload => api.post(urls.DOCUMENT.BLOCKCHAIN_VERIFICATION, payload);
}

export default DocumentService;
